export default {
  methods: {
    async getSessionToken() {
      try {
        const getSessionTokenResponse = await this.$http.get('/session');
        const sessionToken = getSessionTokenResponse.data;

        window.localStorage.setItem('pobr-session', sessionToken);
      } catch (e) {

        // This is here in case there is a leftover blacklisted token in the localStorage, that is saved from a previous POBR and for some reason hasn't been cleared
        if (e.response && e.response.status === 401) {
          window.localStorage.removeItem('pobr-auth');
          this.getSessionToken();
        } else {
          alert("Storitev trenutno ni dostopna.");
          throw e;
        }
      }
    }
  }
}
